import { FaEdit, FaTrash } from 'react-icons/fa';

const Item = (props)=>
{
  const { id, title, removeItem, editItem } = props;
  return (
  <article className = "grocery-item">
      <p className = "title">{title}</p>
      <div class="btn-container">
          <button type = 'button' className = "edit-btn" onClick={()=>{ editItem(id)}}>
              <FaEdit/>
          </button>
          <button type = 'button' className = "delete-btn" onClick={()=>{ removeItem(id)}}>
              <FaTrash/>
          </button>
      </div>
  </article>);
}

export default Item;